export default "__VITE_ASSET__CDdJ02DH__"